import { index as searchApi } from '@afosto/content/api/Index';
import findObjectInArray from '@afosto/utils/array/findObjectInArray';

const DEFAULT_OPTIONS = {
  key: 'sku',
  isFuzzy: false,
};

/**
 * Fetch product information by sku.
 * @param {string} q
 * @param {object} options
 * @param {string} [options.key]
 * @param {boolean} [options.isFuzzy]
 * @returns {Object|null}
 */
export default async (q, options = {}) => {
  try {
    const { key, isFuzzy } = { ...DEFAULT_OPTIONS, ...options };
    const response = await searchApi.search({
      codes: ['pim'],
      models: ['products'],
      namespaces: ['default'],
      q: [q],
      is_fuzzy: isFuzzy,
    });
    const { data } = response;
    const formattedProducts = data.hits.reduce(
      (acc, productData) => [...acc, productData.metadata],
      [],
    );

    return findObjectInArray(formattedProducts, key, q);
  } catch (err) {
    return null;
  }
};
